import { axiosService } from 'service'
import { salesPaymentOrdersEndpoints } from 'service/sources/sales/paymentOrders'

const getBeforeData = () => {
  return axiosService.get(salesPaymentOrdersEndpoints.BEFORE)
}

const list = (query = '', empresa = 1) => {
  return axiosService.get(
    `${salesPaymentOrdersEndpoints.LIST}?${query ? `${query}&` : ''}empresa=${Number(empresa)}`
  )
}

const getOne = (id, empresa = 1) => {
  return axiosService.get(`${salesPaymentOrdersEndpoints.ONE}/${id}/${Number(empresa)}`)
}

const getOneForEdit = async (id, empresa = 1, _fallback = {}) => {
  return axiosService.get(`${salesPaymentOrdersEndpoints.ONE}/${id}/${Number(empresa)}`)
}

const create = async (body) => {
  return await axiosService.post(salesPaymentOrdersEndpoints.CREATE, body)
}

const update = (id, empresa = 1, body) => {
  return axiosService.put(`${salesPaymentOrdersEndpoints.UPDATE}/${id}/${Number(empresa)}`, body)
}

const deletePaymentOrder = (id, empresa = 1) => {
  return axiosService.del(`${salesPaymentOrdersEndpoints.DELETE}/${id}/${Number(empresa)}`)
}

const addPaymentOrderItem = (body) => {
  return axiosService.post(salesPaymentOrdersEndpoints.ADD_ITEM, body)
}

const editPaymentOrderItem = (body) => {
  return axiosService.put(salesPaymentOrdersEndpoints.EDIT_ITEM, body)
}

const deletePaymentOrderItem = (id, empresa = 1, orden) => {
  return axiosService.del(
    `${salesPaymentOrdersEndpoints.DELETE_ITEM}/${id}/${Number(empresa)}/${orden}`
  )
}

const getInvoice = (origen, cliente, orden) => {
  return axiosService.get(`${salesPaymentOrdersEndpoints.INVOICE}/${origen}/${cliente}/${orden}`)
}

const associateComp = (body) => {
  return axiosService.post(salesPaymentOrdersEndpoints.ASSOCIATE_COMP, body)
}

const unassociateComp = (body) => {
  return axiosService.post(salesPaymentOrdersEndpoints.UNASSOCIATE_COMP, body)
}

const generatePaymentOrder = (body) => {
  return axiosService.post(salesPaymentOrdersEndpoints.GENERATE_ORDER, body)
}

const exportToExcel = (body) => {
  return axiosService.post(salesPaymentOrdersEndpoints.EXPORT, body)
}

export const salesPaymentOrders = {
  getOneForEdit,
  getBeforeData,
  list,
  getOne,
  create,
  update,
  deletePaymentOrder,
  addPaymentOrderItem,
  editPaymentOrderItem,
  deletePaymentOrderItem,
  getInvoice,
  associateComp,
  unassociateComp,
  generatePaymentOrder,
  exportToExcel,
}
